export default __webpack_public_path__ + "static/media/a037-student-1-en.83657508.png";